// extracted by mini-css-extract-plugin
export var card = "styles-module--card--1P6In";
export var card_hr = "styles-module--card_hr--2kgVk";
export var card_title = "styles-module--card_title--1j-LI";
export var jsAnimInit = "styles-module--jsAnimInit--1h2do";